import Lenis from '@studio-freight/lenis';

const lenis = new Lenis({
    lerp: .05,
    duration: 6.2,
    orientation: 'vertical',
    gestureOrientation: 'vertical',
    smoothWheel: true,
    smoothTouch: false,
    wheelMultiplier: 1.5,
    touchMultiplier: 1.5,
    normalizeWheel: true,
    easing: (t) => 1 - Math.pow(1 - t, 4),

})

function raf(time) {
  lenis.raf(time)
  requestAnimationFrame(raf)
}

requestAnimationFrame(raf)


